<template>
  <div class="d-flex mt-2">
    <!-- toast -->
    <div v-if="showMessage" class="toast align-items-center text-bg-danger fade show position-fixed top-0 end-0"
      role="alert" aria-live="assertive" aria-atomic="true" data-bs-config='{"delay":5000, "autohide":true}' style="z-index: 9999;">
      <div class="d-flex">
        <div class="toast-body">Teacher Deleted Successfuly.</div>
        <button type="button" class="btn-close me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
      </div>
    </div>
    <!-- end toast -->
    <div class="col-12 table-responsive">
      <div class="col-md-12 text-end mb-1">
        <RouterLink :to="`/teachers/add`" class="col-1 text-right no-underline">
          <button class="btn btn-sm btn-success">
            <i class="fa fa-plus" aria-hidden="true"></i> Add
          </button>
        </RouterLink>
      </div>
       <div class="progress mb-0 progress-sm" v-if="progress!=0">
        <div class="progress-bar" role="progressbar" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100"
          :style="{ width: progress + '%' }"></div>
      </div>
       <DataTable v-if="progress==0" :columns="cols" :rows="rows" :pageSize="10"   :actions="{ view:handleView, edit: handleEdit, delete: handleDelete }" />

    </div>
  <div v-if="showModal" class="modal fade show d-block" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-lg modal-fullscreen-sm-down" role="document">
      <div class="modal-content">
          <div class="modal-header ms-1">
            <h5 class="modal-title color-darknavy" id="studentDetailsModalLabel"> {{ Obj.Name }}
              Details</h5>
              <button type="button" class="btn-close ms-auto" aria-label="Close" @click="closeModal">
        </button>
          </div>
          <div class="modal-body row position-relative ms-1 me-1 ps-0">
            <div class="col-md-5 col-12 order-1 order-md-0">
              <div class="row mb-1">
                <div class="col-md-6 col-6 text-start"> <strong>Name</strong> </div>
                <div class="col-md-6 col-6"> : {{ Obj.Name }} </div>
              </div>
               <div class="row mb-1" v-if="Obj.TeachingClasses">
                <div class="col-md-6 col-6 text-start text-nowrap"> <strong>Teaching-Classes</strong> </div>
                <div class="col-md-6 col-6 text-wrap text-break"> <span class="d-inline-block"><span class="me-1">:</span>{{ Obj.TeachingClasses }} </span> </div>
              </div>
              <div class="row mb-1" v-if="Obj.ClassTeacher">
                <div class="col-md-6 col-6 text-start"> <strong>Class Teacher</strong> </div>
                <div class="col-md-6 col-6"> : {{clsList.find(cls => cls._id == Obj.ClassTeacher)?.name || ''}} </div>
              </div>
              <div class="row mb-1" v-if="Obj.Section">
                <div class="col-md-6 col-6 text-start"> <strong>Section</strong> </div>
                <div class="col-md-6 col-6"> : {{secList.find(cls => cls._id == Obj.Section)?.Name || ''}} </div>
              </div>
              <div class="row mb-1">
                <div class="col-md-6 col-6 text-start"> <strong>Designation</strong> </div>
                <div class="col-md-6 col-6"> : {{ Obj.Designation }} </div>
              </div>
              <div class="row mb-1">
                <div class="col-md-6 col-6 text-start"> <strong>Department</strong> </div>
                <div class="col-md-6 col-6"> : {{ Obj.Department }} </div>
              </div>
              <div class="row mb-1">
                <div class="col-md-6 col-6 text-start"> <strong>Gender</strong> </div>
                <div class="col-md-6 col-6"> : {{ Obj.Gender }} </div>
              </div>
              <div class="row mb-1" v-if="Obj.DOB">
                <div class="col-md-6 col-6 text-start"> <strong>Date of Birth</strong> </div>
                <div class="col-md-6 col-6"> : {{ disDate(Obj.DOB) }} </div>
              </div>
            </div>
            <div class="col-12 col-md-6 order-2 order-md-0 ">
              <div class="row mb-1"  v-if="Obj.About"> <div class="col-md-4 col-6 text-start"> <strong>About</strong> </div>
                <div class="col-md-8 col-6"> : {{ Obj.About }} </div>
              </div>
              <div class="row mb-1" v-if="Obj.BloodGroup">
                <div class="col-md-4 col-6 text-start"> <strong>Blood Group</strong> </div>
                <div class="col-md-8 col-6"> : {{ Obj.BloodGroup }} </div>
              </div>
              <div class="row mb-1">
                <div class="col-md-4 col-6 text-start"> <strong>Contact No</strong> </div>
                <div class="col-md-8 col-6"> : {{ Obj.Phone }} </div>
              </div>
              <div class="row mb-1" v-if="Obj.JoiningDate">
                <div class="col-md-4 col-6 text-start"> <strong>Joining Date</strong> </div>
                <div class="col-md-8 col-6"> : {{ disDate(Obj.JoiningDate) }} </div>
              </div>
              <div class="row mb-1">
                <div class="col-md-4 col-6 text-start"> <strong>Email</strong> </div>
                <div class="col-md-8 col-6"> : {{ Obj.Email }} </div>
              </div>
              <div class="row mb-1">
                <div class="col-md-4 col-6 text-start"> <strong>Address</strong> </div>
                <div class="col-md-8 col-6"> : {{ Obj.Address }} </div>
              </div>
                 <div class="row mb-1" v-if="Obj.Photo">
                  <div class="col-md-4 col-6 text-start"> <strong>Aadhar Photo</strong> </div>
                  <div class="col-md-8 col-6 text-start">
                    : <a :href="getUrl(Obj.Photo)" target="_blank"  class="clearfix"><img :src="getUrl(Obj.Photo)" class="avatar-sm cursor-pointer" role="button" alt="Student Image" /></a>
                  </div>
                </div>
            </div>
            <div class="col-12 col-md-1 text-center order-0 order-md-2 mb-3 mb-md-0 ms-md-n5 ms-0">
          <img :src="getUrl(Obj?.Image)" class="rounded-circle avatar-xl mb-2 cursor-pointer" role="button" alt="teacher Image" />
        </div>
          </div>
           <div class="modal-footer">
              <button type="button" class="btn btn-sm btn-info" @click="closeModal">Close</button>
            </div>
        </div>
      </div>
    </div>
  </div>
   <DelPopup :name="delObj.Name" @delRecord="delRecord" @closeModal="delObj.Name = ''"></DelPopup>
</template>
<script setup>
import DelPopup from "@/components/Common/DelPopup.vue";
import "datatables.net";
import "datatables.net-dt/css/dataTables.dataTables.min.css";
import DataTable from "@/components/Common/DataTable.vue";
import { formatDate, api } from '@/utils/helpers.js';
import { ref, onMounted} from 'vue'
import { useRouter } from 'vue-router'
import { schoolStore } from '@/utils/schoolStore';
const router = useRouter()
const { clsList, secList } = schoolStore();
const  Obj = ref( {})
    const   showMessage = ref(false)
    const delObj= ref([])
    const showModal= ref(false)
   const disDate= (d)=> { return formatDate(d) }
   const cols=ref([
  { label: 'S.No', key: 'Sno' },
  { label: 'Class', key: 'Class' },
  { label: 'Name', key: 'Name' },
  { label: 'Email', key: 'Email' },
  { label: 'Phone', key: 'Phone' },
  { label: 'Designation', key: 'Designation' }
]);
const handleView = (row) => {
   Obj.value={...row}
  showModal.value = true;
}
const closeModal = () => {
  showModal.value = false
}
const handleEdit = (row) => {
    router.push(`/teachers/add?id=${row._id}`)
}
const handleDelete = (row) => {
  delObj.value = { ...row };
}
const rows=ref([])
 const progress = ref(0)
    const loadData= async() => {
        let direction = 1
     let progressInterval = setInterval(() => {
       progress.value += direction
       if (progress.value >= 100) {
         progress.value = 0 
       }
     }, 100)
      await api.get('/teachers/all')
        .then((response) => { rows.value = response.data.map((item, i) => ({ ...item, Sno: i + 1,
         Class: `${clsList.value.find(c => c._id === item.ClassTeacher)?.name || ''}${clsList.value.find(c => c._id === item.ClassTeacher)?.name ? (secList.value.find(s => s._id === item.Section)?.Name ? ' (' + secList.value.find(s => s._id === item.Section)?.Name + ')' : '') : ''}`
         })); 
         progress.value = 0
          clearInterval(progressInterval) });
    }
    const delRecord = async()=> {
      await api.delete(`/teachers/${delObj.value._id}`)
        .then(() => {
          loadData();
           delObj.value = {};
          showMessage.value = true;
        });
    }
    const getUrl = (img) => {
  let imgUrl = !img
    ? "/images/default.png"
    : img.startsWith("..")
      ? img.substring(2)
      : img;

  const base = process.env.VUE_APP_API_URL.replace(/\/+$/, "");
  const path = imgUrl.replace(/^\/+/, "");
  return `${base}/${path}`;
}
     onMounted(() => { loadData() })
</script>
<style scoped>
.stuImage {
  width: 50px;
}
.no-underline {
  text-decoration: none;
}
</style>
